const getDraftGiveawaySessionResponse = (response) => {
  return response?.data?.giveawaySessionHistory ?? {};
};

export default getDraftGiveawaySessionResponse;
